import { render } from "./LiveTestReport.vue?vue&type=template&id=2849ece4&scoped=true&ts=true"
import script from "./LiveTestReport.vue?vue&type=script&lang=ts"
export * from "./LiveTestReport.vue?vue&type=script&lang=ts"

import "./LiveTestReport.vue?vue&type=style&index=0&id=2849ece4&scoped=true&lang=css"
import "./LiveTestReport.vue?vue&type=style&index=1&id=2849ece4&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2849ece4"]])

export default __exports__